import PropTypes from 'prop-types'
import {
  List,
  Avatar,
  ListItem,
  Typography,
  ListItemText,
  ListItemAvatar,
  Badge,
  Box,
} from '@material-ui/core'
import { styled } from '@material-ui/styles'
import profilePic from '../../../../assets/defaultAvatar.png'
import BadgeStatus from 'src/components/BadgeStatus'
import { formatDistanceToNowStrict } from 'date-fns'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import Label from 'src/components/Label'
import { DOMAIN, REST_API_IO } from 'src/constants/DefaultValues'
import { io } from 'socket.io-client'
ChatHomeListSignWise.propTypes = {
  teamMembers: PropTypes.array,
  onSelectContact: PropTypes.func,
}

// Styled Badge for Online Status
const OnlineBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-dot': {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#44b700',
    border: `2px solid ${theme.palette.background.paper}`,
  },
}))
const AvatarWrapperStyle = styled('div')({
  position: 'relative',
  width: 32, // Adjust size for group avatar
  height: 32,
  '& .MuiAvatar-img': { borderRadius: '50%' },
  '& .MuiAvatar-root': { width: '100%', height: '100%' },
})

export default function ChatHomeListSignWise({
  openSidebar,
  setHistoryMessage,
  teamMembers = [],
  onSelectContact,
  setCompose,
  openCompose,
  chatOpenTime,
  setChatOpenTime,
  selectedChatLogId,
  setSelectedChatLogId,
}) {
  console.log('teamMembersdgf', teamMembers)
  const user = JSON.parse(localStorage.getItem('user'))
  const [currentTime, setCurrentTime] = useState(new Date())
  const [typingUsersMap, setTypingUsersMap] = useState({})
  console.log('hhhhhhhhhhhhhhhhhhhhhhhhhhhhhh', typingUsersMap)
  const socketRef = useRef(null)
  // typingUsersMap = { [conversationId]: "John Doe", ... }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 60000)
    return () => clearInterval(interval)
  }, [])
  useEffect(() => {
    socketRef.current = io(REST_API_IO, {
      path: '/socket.io',
      transports: ['websocket', 'polling'],
      secure: true,
    })

    const handleTyping = (data) => {
      if (data?.domain !== DOMAIN) return

      const currentUserId = user?.user_id
      const senderId = data.senderId
      const conversationId = data.conversationId // e.g. 'user_534' or 'chat_8'

      // Don't process if the current user is the sender
      if (senderId === currentUserId) return

      const isGroup = conversationId.startsWith('chat_')
      const isRecipient = isGroup
        ? data.participants?.some((p) => p.user_id === currentUserId)
        : conversationId === `user_${currentUserId}` ||
          conversationId.includes(currentUserId)

      if (!isRecipient) return

      // Correctly use the conversationId as the key
      setTypingUsersMap((prev) => ({
        ...prev,
        [conversationId]:
          data.user?.full_name || data.user?.person_name || 'Someone',
      }))

      setTimeout(() => {
        setTypingUsersMap((prev) => {
          const updated = { ...prev }
          delete updated[conversationId]
          return updated
        })
      }, 3000)
    }

    socketRef.current.on('typing', handleTyping)

    return () => {
      socketRef.current.off('typing', handleTyping) // Correct cleanup
      socketRef.current.disconnect()
    }
  }, [user])

  return (
    <List disablePadding>
      {teamMembers.map((conversation) => {
        console.log('conversation2222222222222', conversation)
        const isGroup = conversation.conversation_type === 'group'
        const otherParticipants = conversation.participants || [] // Assuming 'participants' contains members for the group
        const displayNames = otherParticipants
          .reduce((names, participant) => [...names, participant.full_name], [])
          .join(', ')
        const conversationKey = isGroup
          ? String(conversation.id)
          : `user_${conversation.id}`
        const isTyping = Boolean(typingUsersMap[conversationKey])
        const typingUser = typingUsersMap[conversationKey]
        // console.log('displayNames1', displayNames)

        // return(
        //   <ListItem
        //     key={conversation.id}
        //     button
        //     onClick={() => {onSelectContact(conversation);setCompose(false)}}
        //     sx={{
        //       py: 1.5,
        //       px: 3,
        //       borderRadius: '10px', // ✅ Smooth rounded corners
        //       transition: '0.3s',
        //       '&:hover': { bgcolor: '#0b2329' } // ✅ Correct hover effect (matches first image)
        //     }}
        //   >
        //     <ListItemAvatar>
        //       <OnlineBadge
        //         overlap="circular"
        //         variant={!conversation.active==='N' ? 'dot' : 'standard'}
        //       >
        //         <Avatar alt={conversation.full_name} src={conversation.profile_pic || profilePic} />
        //       </OnlineBadge>
        //     </ListItemAvatar>
        //     {openSidebar && (
        //     <ListItemText
        //     primary={conversation.group_name || conversation.full_name}
        //       secondary={conversation.lastMessage || 'Tap to chat...'}
        //       primaryTypographyProps={{ noWrap: true, variant: 'subtitle2', color: '#fff' }}
        //       secondaryTypographyProps={{ color: 'gray' }}
        //     />
        //     )}
        //     <Typography variant="caption" color="gray">
        //       {conversation.lastActive || '2h'}
        //     </Typography>
        //   </ListItem>
        // )
        return (
          <ListItem
            key={conversation.id}
            button
            onClick={() => {
              // setMobileChat(false)
              onSelectContact(conversation)
              setCompose(false)
              setHistoryMessage([])
              let currentUnixTime = moment().unix()
              console.log('currentUnixTime', currentUnixTime)
              setChatOpenTime(currentUnixTime)
              setSelectedChatLogId(null)
            }}
            sx={{
              py: openSidebar ? 1.5 : 1.2,
              px: openSidebar ? 3 : 1.5,
              borderRadius: '10px',
              transition: '0.3s',
              display: 'flex',
              flexDirection: openSidebar ? 'row' : 'column',
              alignItems: openSidebar ? 'center' : 'center',
              justifyContent: openSidebar ? 'flex-start' : 'center',
              minHeight: openSidebar ? 'auto' : 65,
              '&:hover': { 
                bgcolor: openSidebar ? '#e3e1e1' : 'rgba(2, 125, 194, 0.1)',
                transform: openSidebar ? 'none' : 'scale(1.05)',
              },
            }}
          >
            <ListItemAvatar
              sx={{
                minWidth: openSidebar ? 'auto' : 'auto',
                marginRight: openSidebar ? 2 : 0,
                marginBottom: openSidebar ? 0 : 1,
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: openSidebar ? 48 : 44,
                  height: openSidebar ? 48 : 44,
                  '& .avatarWrapper': {
                    position: 'absolute',
                    width: openSidebar ? 32 : 30,
                    height: openSidebar ? 32 : 30,
                    '&:nth-child(1)': {
                      left: 0,
                      zIndex: 9,
                      bottom: 2,
                      '& .MuiAvatar-root': { border: 'solid 2px #000' },
                    },
                    '&:nth-child(2)': { top: 2, right: 0 },
                  },
                }}
              >
                {isGroup &&
                  otherParticipants.slice(0, 2).map((participant) => (
                    <AvatarWrapperStyle
                      className="avatarWrapper"
                      key={participant.id}
                    >
                      <Avatar
                        alt={participant?.full_name}
                        src={participant?.profile_pic || profilePic}
                        sx={{
                          width: openSidebar ? 32 : 30,
                          height: openSidebar ? 32 : 30,
                        }}
                      />
                      {openSidebar && (
                        <BadgeStatus
                          status={participant?.status || 'offline'}
                          sx={{ right: 2, bottom: 2, position: 'absolute' }}
                        />
                      )}
                    </AvatarWrapperStyle>
                  ))}
                {!isGroup && (
                  <Avatar
                    alt={conversation?.full_name}
                    src={conversation?.profile_pic || profilePic}
                    sx={{
                      width: openSidebar ? 48 : 44,
                      height: openSidebar ? 48 : 44,
                    }}
                  />
                )}
              </Box>
            </ListItemAvatar>

            {openSidebar ? (
              <>
                <ListItemText
                  primary={
                    isGroup ? (
                      conversation.group_name
                    ) : (
                      <>
                        {conversation.full_name}
                        {conversation.user_type === 'client' && (
                          <span style={{ color: 'primary.main' }}>
                            {' '}
                            (Client)
                          </span>
                        )}
                      </>
                    )
                  }
                  primaryTypographyProps={{
                    noWrap: true,
                    variant: 'subtitle2',
                    color: '#000',
                  }}
                  secondary={
                    isTyping ? (
                      <Typography
                        component="span"
                        style={{ fontStyle: 'italic', color: '#ccc' }}
                      >
                        {isGroup ? `${typingUser} is typing...` : 'typing...'}
                      </Typography>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: isGroup
                            ? conversation?.last_message
                              ? `${
                                  conversation?.last_message_sender_id ===
                                  user.user_id
                                    ? 'You'
                                    : conversation?.last_message_sender
                                }: ${conversation?.last_message
                                  .replace(/<\/p><p>/g, ' ')
                                  .replace(/<p>/g, '')
                                  .replace(/<\/p>/g, '')
                                  .trim()}`
                              : 'Tap to chat...'
                            : conversation?.last_message
                            ? conversation?.last_message
                                .replace(/<\/p><p>/g, ' ')
                                .replace(/<p>/g, '')
                                .replace(/<\/p>/g, '')
                                .trim()
                            : 'Tap to chat...',
                        }}
                      />
                    )
                  }
                  secondaryTypographyProps={{
                    color: 'gray',
                    noWrap: true,
                  }}
                />
                <Box
                  sx={{
                    ml: 2,
                    height: 44,
                    display: 'flex',
                    alignItems: 'flex-end',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    sx={{
                      mb: 1.25,
                      fontSize: 12,
                      lineHeight: '22px',
                      whiteSpace: 'nowrap',
                      color: 'text.disabled',
                    }}
                  >
                    {conversation?.last_message_time
                      ? (() => {
                          const messageTime = new Date(
                            moment.unix(conversation?.last_message_time),
                          )
                          const distance = formatDistanceToNowStrict(
                            messageTime,
                            { addSuffix: false, baseDate: currentTime },
                          )
                          if (distance.includes('second')) {
                            return 'just now'
                          }
                          return distance
                        })()
                      : ''}
                  </Box>
                  {conversation?.unread_messages > 0 && (
                    <Label
                      variant="ghost"
                      color="primary"
                      sx={{
                        padding: '10px',
                        borderRadius: '25px',
                        marginTop: '-10px',
                      }}
                    >
                      {conversation.unread_messages > 99
                        ? '99+'
                        : conversation.unread_messages}
                    </Label>
                  )}
                </Box>
              </>
            ) : (
              // Collapsed state - show only avatar and truncated name
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '100%',
                  position: 'relative',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: '11px', // Slightly larger font
                    fontWeight: 600, // Bolder font weight
                    color: 'text.primary',
                    textAlign: 'center',
                    lineHeight: 1.3,
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    mt: 0.5,
                    transition: 'color 0.2s ease-in-out',
                    px: 1, // More padding for better spacing
                    width: '100%',
                    display: 'block',
                    letterSpacing: '0.02em', // Better letter spacing
                  }}
                  title={isGroup ? conversation.group_name : conversation.full_name} // Show full name on hover
                >
                  {isGroup ? conversation.group_name : conversation.full_name}
                </Typography>
                {conversation?.unread_messages > 0 && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -5,
                      right: 5,
                      backgroundColor: '#ff4444',
                      color: 'white',
                      borderRadius: '50%',
                      minWidth: 16,
                      height: 16,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      animation: 'pulse 2s infinite',
                      '@keyframes pulse': {
                        '0%': {
                          transform: 'scale(1)',
                          opacity: 1,
                        },
                        '50%': {
                          transform: 'scale(1.1)',
                          opacity: 0.8,
                        },
                        '100%': {
                          transform: 'scale(1)',
                          opacity: 1,
                        },
                      },
                    }}
                  >
                    {conversation.unread_messages > 9 ? '9+' : conversation.unread_messages}
                  </Box>
                )}
              </Box>
            )}
          </ListItem>
        )
      })}
    </List>
  )
}
